import axiosInstance from 'api/axiosInstance';

export interface ActiveOverstay {
	ticketNumber: string;
	licenseNumber: string;
	licenseState: string;
	parkingLocationId: string;
	parkingLocationName: string;
	companyId: string;
	vehicleInfo: string | null;
	loggedAt: string; // ISO 8601 UTC
	maxStayMinutes: number;
	minutesOverstayed: number;
}

export const getActiveOverstays = async (
	companyIds: string[],
): Promise<ActiveOverstay[]> => {
	if (!companyIds || companyIds.length === 0) return [];

	// POST (not GET) so users with hundreds of customers don't blow IIS's
	// max URL length.
	const response = await axiosInstance.post(
		`/api2.0/overstays/getActiveOverstays`,
		{ companyIds: companyIds.map((id) => Number(id)).filter((n) => n > 0) },
		{ headers: { 'Content-Type': 'application/json' } },
	);

	return (response.data || []).map(
		(row: any): ActiveOverstay => ({
			ticketNumber: String(row.ticketNumber),
			licenseNumber: String(row.licenseNumber),
			licenseState: String(row.licenseState),
			parkingLocationId: String(row.parkingLocationId),
			parkingLocationName: String(row.parkingLocationName ?? ''),
			companyId: String(row.companyId ?? ''),
			vehicleInfo: row.vehicleInfo ?? null,
			loggedAt: String(row.loggedAt),
			maxStayMinutes: Number(row.maxStayMinutes),
			minutesOverstayed: Number(row.minutesOverstayed),
		}),
	);
};
